import { ACHIEVEMENTS_DATA, type AchievementDef } from "@/lib/data";

// Achievement records now live in src/data/source/achievements.json, transcribed from the
// original spreadsheet (each record keeps its `sourceRow` for provenance).
//
// `achieved` is still present on every record and null on every record — it is per-player
// progress, not catalog data. See the note on AchievementDef in src/data/schema/types.ts:
// a real progress tracker should own that in local storage and drop the field from the data
// layer. It is retained for now only so this feature's existing components keep compiling.

export type HeartopiaAchievement = AchievementDef;

export const ACHIEVEMENTS: HeartopiaAchievement[] = ACHIEVEMENTS_DATA;

/** Base path for achievement images in public/achievements/ (.webp) */
const ACHIEVEMENT_IMAGES_BASE = "/achievements";

/** Map achievement id -> filename (no extension) when it differs from id (typos baked into the asset filenames) */
const ACHIEVEMENT_IMAGE_FILES: Record<string, string> = {
  "animal-neighbour": "animal-neighbor",
  "fast-and-flawless": "fast-n-flawless",
  "plentiful-harvest": "pentiful-harvest",
  "golden-music-cd": "golde-music-cd",
  "swarm-commander": "swarn-commander",
};

export function getAchievementImageUrl(id: string): string {
  const filename = ACHIEVEMENT_IMAGE_FILES[id] ?? id;
  return `${ACHIEVEMENT_IMAGES_BASE}/${filename}.webp`;
}

export function getAchievementById(id: string): HeartopiaAchievement | undefined {
  return ACHIEVEMENTS.find((achievement) => achievement.id === id);
}

export function getAchievementsByHobby(hobby: string | null): HeartopiaAchievement[] {
  return ACHIEVEMENTS.filter((achievement) => achievement.hobby === hobby);
}

export function getVisibleAchievements(): HeartopiaAchievement[] {
  return ACHIEVEMENTS.filter((achievement) => !achievement.isHidden);
}

export function getAllHobbies(): string[] {
  const hobbies = ACHIEVEMENTS.map((achievement) => achievement.hobby).filter(
    (hobby): hobby is string => hobby !== null,
  );
  return [...new Set(hobbies)].sort();
}
